module.exports = __webpack_public_path__ + "media/images/flags/16/Basque-Country-9ef13c69dea597f819f80c867eb192dc.png";